export const REPORTS_ROUTE_NAMES = {
  BUYER_METRICS: 'buyer-metrics',
  BUYER_REPLENISHMENTS: 'buyer-replenishments',
  BUYER_REPORTS: 'buyer-reports',
  CATEGORY_MANAGEMENT_INSIGHTS: 'category-management-insights',
  COMPANY_BRAND_OWNER_REPORTS: 'company-brand-owner-reports',
  ORDERS_REPORT: 'orders-report',
  PRODUCT_PERFORMANCE_REPORT: 'product-performance-report',
  PURCHASING_INSIGHTS: 'purchasing-insights',
  REPORT_SCHEDULE: 'report-schedule',
  REPORTS_ADVERTISING: 'reports-advertising',
  REPORTS_ADVERTISING_INSIGHTS: 'reports-advertising-insights',
  REPORTS_MARKET_INSIGHTS: 'reports-market-insights',
  REPORTS_BUSINESS_INSIGHTS: 'reports-business-report',
  REPORTS_PAYMENT_ON_SELL_THROUGH_INSIGHTS: 'payment-on-sell-through-insights',
  REPORTS: 'reports',
  RETAILER_DASHBOARD: 'retailer-dashboard',
  SALES_DASHBOARD: 'sales-dashboard',
  SELLER_STATUS: 'seller-status',
  SELLER_USAGE_REPORT: 'seller-usage-report',
  INVENTORY_INSIGHTS: 'inventory-insights',
  BUYERS_CLUB_INSIGHTS: 'buyers-club-insights',
  PRODUCTS_SOLD_REPORT: 'products-sold',
  BRAND_PERFORMANCE: 'brand-performance-report',
  REPORT_DOWNLOADS: 'report-downloads',
  REPORT_FULFILLMENT_TABLEAU: 'll-insights-tableau-fulfillment',
  ACCOUNTS_RECEIVABLE_REPORT: 'accounts-receivable-report',
  ORDER_PAYMENTS_REPORT: 'order-payments-report',
  INVENTORY_OVERVIEW_REPORT: 'inventory-overview-report',
  PRODUCT_LINES_REPORT: 'product-lines-report',
  BACKORDERED_ORDERS_REPORT: 'backordered-orders-report',
  RESERVED_INVENTORY_REPORT: 'reserved-inventory-report',
  TEAM_SALES_REPORT: 'team-sales-report',
  SALES_REPRESENTATIVE_ACTIVITY_REPORT: 'sales-representative-activity-report',
  SALES_REPRESENTATIVE_TASK_REPORT: 'sales-representative-task-report',
  SALES_REPRESENTATIVE_ACTIVITY_FEED: 'sales-representative-activity-feed',
  CUSTOMER_LAST_ORDER_REPORT: 'customer-last-order-report',
  CUSTOMER_VALUE_REPORT: 'customer-value-report',
  CUSTOMER_LOCATIONS_REPORT: 'customer-locations-report',
};
